import React from 'react';
import { AnimatePresence, motion } from 'motion/react';
import { SiteTransitions } from '../../../utils/transitions';
import EdgeNav from './Nav/EdgeNav';
import { Outlet } from 'react-router';
import EdgeFooter from './Footer/EdgeFooter';
import EdgePhotoGrid from './Body/EdgePhotoGrid';
import EdgeMerchNotice from './Body/Home/EdgeMerchNotice';


const EdgeMain: React.FC = () => {
    return (
        <motion.div
            variants={SiteTransitions}
            initial='initial'
            animate='animate'
            exit='exit'
            className='flex flex-col size-full'
        >
            <EdgeNav />
            <main
                className='grow flex flex-col text-grenze'
            >
                <EdgePhotoGrid />
                <AnimatePresence mode='wait'>
                    <Outlet />
                </AnimatePresence>
                <EdgeMerchNotice />
            </main>
            <EdgeFooter />
        </motion.div>
    )
}

export default EdgeMain;